import { Box, Typography } from "@mui/material";
import { N } from "framer-motion/dist/types.d-CQt5spQA";
import { LikertScale } from "../questionnaireComponents/LikertScale";

export type godSpeedType = {
  // anthropomorphism 擬人性
  natural: number | null;
  humanlike: number | null;
  conscious: number | null;
  lifelike: number | null;
  movingElegant: number | null;

  // animacy 有生性
  alive: number | null;
  lively: number | null;
  organic: number | null;
  biological: number | null; // lifelikeと同様 生物性
  interactive: number | null;
  responsive: number | null;

  // likeability 好感度
  like: number | null;
  friendly: number | null;
  kind: number | null;
  pleasant: number | null;
  nice: number | null;

  // perceived intelligence 知能の有無
  competent: number | null;
  knowledgeable: number | null;
  responsible: number | null;
  intelligent: number | null;
  sensible: number | null;

  // perceived safety 安心感の有無
  relaxed: number | null;
  calm: number | null;
  surprised: number | null;
};

export const defaultGodSpeedAnswer: godSpeedType = {
  natural: null,
  humanlike: null,
  conscious: null,
  lifelike: null,
  movingElegant: null,
  alive: null,
  lively: null,
  organic: null,
  biological: null,
  interactive: null,
  responsive: null,
  like: null,
  friendly: null,
  kind: null,
  pleasant: null,
  nice: null,
  competent: null,
  knowledgeable: null,
  responsible: null,
  intelligent: null,
  sensible: null,
  relaxed: null,
  calm: null,
  surprised: null,
};

interface godSpeedProps {
  godSpeedAnswer: godSpeedType;
  setGodSpeedAnswer: React.Dispatch<React.SetStateAction<godSpeedType>>;
}

// const godSpeedQuestions = [
//   { key: "natural", left: "偽物のような", right: "自然な" },
//   { key: "humanlike", left: "機械的", right: "人間的" },
//   { key: "conscious", left: "意識を持たない", right: "意識を持っている" },
//   { key: "lifelike", left: "人工的", right: "生物的" },
//   { key: "movingElegant", left: "ぎこちない動き", right: "洗練された動き" },
//   { key: "alive", left: "死んでいる", right: "生きている" },
//   { key: "lively", left: "活気のない", right: "生き生きとした" },
//   { key: "organic", left: "機械的な", right: "有機的な" },
//   { key: "biological", left: "人工的な", right: "生物的な" },
//   { key: "interactive", left: "不活発な", right: "対話的な" },
//   { key: "responsive", left: "無関心な", right: "反応のある" },
//   { key: "like", left: "嫌い", right: "好き" },
//   { key: "friendly", left: "親しみにくい", right: "親しみやすい" },
//   { key: "kind", left: "不親切な", right: "親切な" },
//   { key: "pleasant", left: "不愉快な", right: "愉快な" },
//   { key: "nice", left: "ひどい", right: "良い" },
//   { key: "competent", left: "無能な", right: "有能な" },
//   { key: "knowledgeable", left: "無知な", right: "物知りな" },
//   { key: "responsible", left: "無責任な", right: "責任のある" },
//   { key: "intelligent", left: "知的でない", right: "知的な" },
//   { key: "sensible", left: "愚かな", right: "賢明な" },
//   { key: "relaxed", left: "不安な", right: "落ち着いた" },
//   { key: "calm", left: "冷静な", right: "動揺している" },
//   { key: "surprised", left: "平穏な", right: "驚いた" },
// ] as const;

const godSpeedQuestionsRandom = [
  { key: "organic", left: "機械的な", right: "有機的な" },
  { key: "calm", left: "冷静な", right: "動揺している" },
  { key: "biological", left: "人工的な", right: "生物的な" },
  { key: "sensible", left: "愚かな", right: "賢明な" },
  { key: "movingElegant", left: "ぎこちない", right: "洗練された動き" },
  { key: "responsible", left: "無責任な", right: "責任のある" },
  { key: "like", left: "嫌い", right: "好き" },
  { key: "humanlike", left: "機械的", right: "人間的" },
  { key: "alive", left: "死んでいる", right: "生きている" },
  { key: "nice", left: "ひどい", right: "良い" },
  { key: "competent", left: "無能な", right: "有能な" },
  { key: "intelligent", left: "知的でない", right: "知的な" },
  { key: "conscious", left: "意識を持たない", right: "意識を持っている" },
  { key: "surprised", left: "平穏な", right: "驚いた" },
  { key: "pleasant", left: "不愉快な", right: "愉快な" },
  { key: "relaxed", left: "不安な", right: "落ち着いた" },
  { key: "knowledgeable", left: "無知な", right: "物知りな" },
  { key: "kind", left: "不親切な", right: "親切な" },
  { key: "natural", left: "偽物のような", right: "自然な" },
  { key: "lifelike", left: "人工的", right: "生物的" },
  { key: "lively", left: "活気のない", right: "生き生きとした" },
  { key: "interactive", left: "不活発な", right: "対話的な" },
  { key: "responsive", left: "無関心な", right: "反応のある" },
  { key: "friendly", left: "親しみにくい", right: "親しみやすい" },
] as const;

export const GodSpeed: React.FC<godSpeedProps> = ({
  godSpeedAnswer,
  setGodSpeedAnswer,
}) => {
  return (
    <>
      <Box sx={{ padding: "1rem" }}>
        <Typography variant="body1">※この設問は初日のみ回答頂きます</Typography>
        <div style={{ height: "1rem" }} />
        <Typography variant="caption">
          以下のスケールに基づいてこのAI Chatbotの印象を評価してください。
        </Typography>
        <div style={{ height: "2rem" }} />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          {godSpeedQuestionsRandom.map(({ key, left, right }) => (
            <Box
              key={key}
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr auto 1fr",
                alignItems: "center",
                gap: "1rem",
                width: "100%",
                maxWidth: "400px",
              }}
            >
              <Typography variant="body2" sx={{ textAlign: "right" }}>
                {left}
              </Typography>
              <LikertScale
                likertLength={5}
                answerValue={godSpeedAnswer[key]}
                onChange={(value) =>
                  setGodSpeedAnswer({ ...godSpeedAnswer, [key]: value })
                }
                short
              />
              <Typography variant="body2" sx={{ textAlign: "left" }}>
                {right}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};
